import React, { useEffect, useState } from "react";
import FormCampoCBX from "../componente/FormCampoCBX";
import Credito from "./Credito";


const dataSimulador = require("./simulacionCreditos.json");

const noValue = "- Seleccionar -";
// Create our number formatter.
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
  
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const fnSort = (a, b) => {
  if (a === b) {
    return 0;
  }
  
  return a > b ? 1 : -1;
};


let smonto = new Set();
let splazo = new Set();
dataSimulador.forEach(k => {
  smonto.add(k.monto);
  splazo.add(k.plazo_meses);
});

const listaMonto = [noValue, ...Array.from(smonto).sort(fnSort)];
const listaPlazo = [noValue, ...Array.from(splazo).sort(fnSort)];

const simuladorConfig = ({ monto: listaMonto, plazo: listaPlazo });

const Simulador = () => {
  
  const [monto, setMonto] = useState(noValue);
  const [plazo, setPlazo] = useState(noValue);
  
  useEffect(() => {
    
  
  }, []);
  
  const listaOpcionMonto = simuladorConfig.monto.map(k => {
    const label = k === noValue ? noValue : formatter.format(k);
    return { valor: k, label };
  });
  
  const listaOpcionPlazo = simuladorConfig.plazo.map(k => {
    const label = k === noValue ? noValue : `${k} Meses`;
    return { valor: k, label };
  });
  return (
    <>
      <FormCampoCBX label="Monto "
                    listaOptionsCBX={listaOpcionMonto}
                    valor={monto}
                    setValor={setMonto} />
      
      <FormCampoCBX label="Plazo "
                    listaOptionsCBX={listaOpcionPlazo}
                    valor={plazo}
                    setValor={setPlazo} />
      <hr />
      <Credito
        monto={monto} plazo={plazo} simulacionCreditos={dataSimulador} />

    </>
  );
};

export default Simulador;